import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=28dc57af&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=ts"
export * from "./MultipleSelect.vue?vue&type=script&lang=ts"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&id=28dc57af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc57af",
  null
  
)

export default component.exports